export const containers = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};
